import {
  isNonNullable
} from "./chunk-ARWLRO3D.mjs";

// lib/hooks/use-outside-click.ts
import { useEffect, useRef } from "react";
var useOutsideClick = (handler, ref) => {
  const listener = useRef();
  listener.current = handler;
  const hasHandler = isNonNullable(handler);
  useEffect(() => {
    if (!hasHandler) {
      return;
    }
    const handleClickOutside = (event) => {
      const refs = (Array.isArray(ref) ? ref : [ref]).filter(isNonNullable);
      if (!refs.some((ref2) => ref2.contains(event.target))) {
        listener.current && listener.current(event);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, hasHandler]);
};

export {
  useOutsideClick
};
